import React from 'react'
import Errors from '../errors'

const ErrorsNo = () => {
    return <Errors languageCode="no" />
}

export default ErrorsNo
